import { AuthClientItem } from '@jupiterone/jupiter-web-toolkit';
import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@material-ui/core';
import React from 'react';
import { Lock } from 'react-feather';
import AccountPageListItem, {
  AccountPageListItemProps,
} from '../../AccountPageList/AccountPageListItem';

export default class AuthClientListItem extends AccountPageListItem<AuthClientItem> {
  constructor(props: AccountPageListItemProps<AuthClientItem>) {
    super(props);
  }

  render() {
    const { classes, item } = this.props;
    return (
      <ListItem className={classes.listItem}>
        <ListItemAvatar>
          <Avatar className={classes.groupAvatar}>
            <Lock />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          disableTypography={false}
          classes={{
            primary: classes.primaryInvitation,
            secondary: classes.secondaryInvitation,
          }}
          onClick={this.selectItem}
          primary={item.name}
        />
      </ListItem>
    );
  }
}
